export default __webpack_public_path__ + "static/Payments-2dcca800261892d35f41096b81f4d327.png";